module.exports = __webpack_public_path__ + "img/ajuda_protesto.e0ba5009.jpg";